export default __webpack_public_path__ + "static/media/new-bookmark.e56bf0df.svg";